/* tslint:disable */
/* eslint-disable */
/**
 * My App API
 * My App API description
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface CreateUserPasswordResetRequest
 */
export interface CreateUserPasswordResetRequest {
    /**
     * 
     * @type {string}
     * @memberof CreateUserPasswordResetRequest
     */
    account: string;
    /**
     * 
     * @type {string}
     * @memberof CreateUserPasswordResetRequest
     */
    role: CreateUserPasswordResetRequestRoleEnum;
}

/**
* @export
* @enum {string}
*/
export enum CreateUserPasswordResetRequestRoleEnum {
    Aao = 'aao',
    Approve = 'approve',
    Office = 'office'
}

export function CreateUserPasswordResetRequestFromJSON(json: any): CreateUserPasswordResetRequest {
    return CreateUserPasswordResetRequestFromJSONTyped(json, false);
}

export function CreateUserPasswordResetRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): CreateUserPasswordResetRequest {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'account': json['account'],
        'role': json['role'],
    };
}

export function CreateUserPasswordResetRequestToJSON(value?: CreateUserPasswordResetRequest | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'account': value.account,
        'role': value.role,
    };
}


